import {
  // PermissionKey,
  GrantTypeLabel,
  PlanScopeLabel,
  // AdvertiserAccountTypeLabel,
  statusOptions,
  playStatusOptions,
  currencyOptions,
  taxForAdvOptions,
} from '@/common/permission'
import { testList } from '@/views/producer/common-template/selling-strategy.js'
import { getTotalAmount, getMaxAmount } from '../utils'

export default {
  data() {
    return {
      statusOptions,
    }
  },
  computed: {
    _tableColumnConfig() {
      const _default = [
        {
          label: '广告主ID',
          prop: 'adv_id',
          width: 120,
          fixed: 'left',
        },
        {
          label: '广告主名称',
          prop: 'adv_name',
          width: 130,
          fixed: 'left',
        },
        // {
        //   label: '账号类型',
        //   prop: 'mws_account_type',
        //   params: {
        //     innerHTML: ({ row }) => {
        //       return AdvertiserAccountTypeLabel[row.mws_account_type] || ''
        //     },
        //   },
        // },
        {
          label: '订阅类型',
          prop: 'grant_type',
          params: {
            innerHTML: ({ row }) => {
              return GrantTypeLabel[row.grant_type] || ''
            },
          },
        },
        {
          label: '授权范围',
          prop: 'plan_scope',
          params: {
            innerHTML: ({ row }) => {
              return PlanScopeLabel[row.plan_scope] || ''
            },
          },
        },
        {
          label: '套餐名称',
          prop: 'plan_name',
          width: 140,
        },
        {
          label: '主套餐ID',
          prop: 'plan_id',
        },
        {
          label: '授权可玩模板',
          slot: 'template-cell',
        },
        {
          label: '授权可玩渠道',
          slot: 'channel-cell',
        },
        {
          label: '可玩下载量',
          prop: 'plan_download',
          width: 100,
          params: {
            innerHTML: ({ row }) => {
              const value = getMaxAmount(row, 'download_push')
              return value || '-'
            },
          },
        },
        {
          label: '在线人数',
          prop: 'plan_online',
          params: {
            innerHTML: ({ row }) => {
              const value = getMaxAmount(row, 'online')
              return value || '-'
            },
          },
        },
        {
          label: '存储空间（G）',
          prop: 'plan_storage',
          width: 120,
          params: {
            innerHTML: ({ row }) => {
              return this.cookUnlimited(row.plan_settings.storage)
            },
          },
        },
        {
          label: '授权生效时间',
          prop: 'effective_time',
          width: 140,
        },
        {
          label: '授权天数',
          prop: 'days',
          width: 80,
          params: {
            innerHTML: ({ row }) => {
              return row.days ? row.days + '天' : '-'
            },
          },
        },
        {
          label: '授权到期时间',
          prop: 'expired_time',
          width: 140,
        },
        {
          label: '授权状态',
          prop: 'status',
          width: 100,
          params: {
            innerHTML: ({ row }) => {
              return this.statusOptions[row.status] || ''
            },
          },
        },
        {
          label: '授权功能',
          prop: 'permission_names',
          width: 200,
        },
        {
          label: '是否测试账号',
          prop: 'is_test',
          width: 100,
          params: {
            innerHTML: ({ row }) => {
              const temp = testList.find((s) => s.value === row.is_test)
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: '重置周期（天）',
          prop: 'reset_day',
          params: {
            innerHTML: ({ row }) => {
              return row.reset_day ? row.reset_day + '天' : '-'
            },
          },
        },
        {
          label: '可玩MTG是否计费',
          prop: 'mtg_charge',
          params: {
            innerHTML: ({ row }) => {
              if (row.mtg_charge) {
                return row.mtg_charge === 1 ? '是' : '否'
              }
              return '-'
            },
          },
        },
        {
          label: '可玩额度（条/周期）',
          prop: 'download_push',
          width: 140,
          params: {
            innerHTML: ({ row }) => {
              const value = getTotalAmount(row, 'download_push')
              return value || '-'
            },
          },
        },
        {
          label: '视频额度（点/周期）',
          prop: 'video_credits',
          width: 140,
          params: {
            innerHTML: ({ row }) => {
              const value = getTotalAmount(row, 'video_credits')
              return value || '-'
            },
          },
        },
        {
          label: '最大存储语音数',
          prop: 'voice_slots',
          width: 140,
          params: {
            innerHTML: ({ row }) => {
              return this.cookUnlimited(row.plan_settings.voice_slots)
            },
          },
        },
        {
          label: '语音编辑数',
          prop: 'voice_edits',
          width: 140,
          params: {
            innerHTML: ({ row }) => {
              return this.cookUnlimited(row.plan_settings.voice_edits)
            },
          },
        },
        {
          label: '付费金额',
          prop: 'revenue',
          width: 120,
          params: {
            innerHTML({ row }) {
              if (typeof row.revenue === 'number') {
                return row.revenue === 0
                  ? '免费（0）'
                  : `付费（${row.revenue}）`
              }
              return '-'
            },
          },
        },
        {
          label: '授权添加时间',
          prop: 'created_time',
          width: 140,
          sortable: 'custom',
          params: {
            sortable: 'custom',
          },
        },
        {
          label: '操作时间',
          prop: 'updated_time',
          width: 140,
        },
        {
          label: '操作人',
          prop: 'admin_name',
          width: 140,
        },
        {
          label: '备注',
          prop: 'reason',
          params: {
            innerHTML({ row }) {
              return row.reason ? JSON.parse(row.reason).reason : '-'
            },
          },
        },
        {
          prop: 'contract_code',
          label: '合同编码',
          params: {
            innerHTML({ row }) {
              return row.contract_code ? row.contract_code : '-'
            },
          },
        },
      ]

      return _default
    },
    _rechargeTableColumnConfig() {
      const _default = [
        {
          label: '支付来源',
          prop: 'type',
          params: {
            innerHTML: ({ row }) => {
              return row.type === 1 ? '人工充值' : '在线充值'
            },
          },
        },
        {
          label: '3s 用户名',
          prop: 'username_3s',
        },
        {
          label: '广告主ID',
          prop: 'adv_id',
        },
        {
          label: '广告主名称',
          width: 100,
          prop: 'adv_name',
        },
        {
          label: '是否测试账号',
          prop: 'is_test',
          width: 100,
          params: {
            innerHTML: ({ row }) => {
              const temp = testList.find((s) => s.value === row.is_test)
              return temp ? temp.label : '-'
            },
          },
        },
        {
          label: '客户国家',
          prop: 'country_code',
        },
        {
          label: '客户主体',
          prop: 'partner_name',
        },
        {
          label: '我方主体',
          prop: 'receive_company_name',
          width: 150,
        },
        {
          label: '合同编码',
          prop: 'contract_code',
        },
        {
          label: '套餐类型',
          prop: 'plan_name',
        },
        {
          label: '收款金额',
          prop: 'bill_amount',
          dataFormat: {
            type: 'number', // string，可选 number/text/percentage/currency/permillage
            thousandsSeparator: true, // boolean，是否要千位分隔符
          },
        },
        {
          label: '支付手续费',
          prop: 'fee',
          width: 100,
          dataFormat: {
            type: 'number', // string，可选 number/text/percentage/currency/permillage
            thousandsSeparator: true, // boolean，是否要千位分隔符
          },
        },
        {
          label: '支付税费',
          prop: 'tax',
          dataFormat: {
            type: 'number', // string，可选 number/text/percentage/currency/permillage
            thousandsSeparator: true, // boolean，是否要千位分隔符
          },
        },
        {
          label: '可用收款金额',
          prop: 'real_money',
          width: 100,
          dataFormat: {
            type: 'number', // string，可选 number/text/percentage/currency/permillage
            thousandsSeparator: true, // boolean，是否要千位分隔符
          },
        },
        {
          label: '退款金额',
          prop: 'refund_money',
          dataFormat: {
            type: 'number', // string，可选 number/text/percentage/currency/permillage
            thousandsSeparator: true, // boolean，是否要千位分隔符
          },
        },
        {
          label: '币种',
          prop: 'currency',
          params: {
            innerHTML: ({ row }) => {
              return currencyOptions[row.currency] || ''
            },
          },
        },
        {
          label: 'tax_for_adv',
          prop: 'tax_for_adv',
          width: 100,
          params: {
            innerHTML: ({ row }) => {
              return taxForAdvOptions[row.tax_for_adv] || ''
            },
          },
        },
        {
          label: '支付状态',
          prop: 'status',
          params: {
            innerHTML: ({ row }) => {
              return playStatusOptions[row.status] || ''
            },
          },
        },
        {
          label: '支付成功时间',
          prop: 'created_time',
          width: 170,
        },
        {
          label: '最后操作时间',
          prop: 'updated_time',
          width: 170,
        },
        {
          label: '操作人',
          prop: 'updated_uname',
          params: {
            innerHTML: ({ row }) => {
              return row.updated_uname || '-'
            },
          },
        },
        {
          label: '备注',
          slot: 'remark',
        },
        {
          label: '退款原因',
          prop: 'refund_reason',
          params: {
            innerHTML: ({ row }) => {
              return row.refund_reason || '-'
            },
          },
        },
        {
          slot: 'action-cell',
        },
      ]

      return _default
    },
  },
  methods: {
    renderPermissionLabel(row, key) {
      const permissions = row.permissions.split(',')
      return permissions.includes(key) ? 'Yes' : 'No'
    },

    cookUnlimited(val) {
      if (!val) {
        return '-'
      }
      if (val && val.amount === -1) {
        return '无限制'
      }
      return val.amount
    },
  },
}
